/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AutoMLTrainingJob = {
  created_by: string
  training_data: string | null
  resulting_model: string | null
  readonly uuid: string
  readonly created_at: string
  /**
   * Represents the time the training script was started
   */
  readonly started_at: string | null
  /**
   * Represents the time the training job finished
   */
  readonly ended_at: string | null
  /**
   * Represents the time the training job was cancelled
   */
  readonly cancelled_at: string | null
  /**
   * * `PENDING` - Pending
   * * `RUNNING` - Running
   * * `SUCCEEDED` - Succeeded
   * * `FAILED` - Failed
   * * `CANCELLED` - Cancelled
   * * `TIMEOUT` - Timeout
   */
  readonly status: AutoMLTrainingJob.status
  resulting_model_name?: string
  /**
   * * `live` - Live
   * * `challenger` - Challenger
   * * `disabled` - Disabled
   * * `pending-action` - Pending Action
   */
  resulting_model_state?: AutoMLTrainingJob.resulting_model_state
  /**
   * File having metrics calculated for all the given thresholds
   */
  readonly threshold_metrics: string | null
  readonly duration: string | null
}
export namespace AutoMLTrainingJob {
  /**
   * * `PENDING` - Pending
   * * `RUNNING` - Running
   * * `SUCCEEDED` - Succeeded
   * * `FAILED` - Failed
   * * `CANCELLED` - Cancelled
   * * `TIMEOUT` - Timeout
   */
  export enum status {
    PENDING = "PENDING",
    RUNNING = "RUNNING",
    SUCCEEDED = "SUCCEEDED",
    FAILED = "FAILED",
    CANCELLED = "CANCELLED",
    TIMEOUT = "TIMEOUT",
  }
  /**
   * * `live` - Live
   * * `challenger` - Challenger
   * * `disabled` - Disabled
   * * `pending-action` - Pending Action
   */
  export enum resulting_model_state {
    LIVE = "live",
    CHALLENGER = "challenger",
    DISABLED = "disabled",
    PENDING_ACTION = "pending-action",
  }
}
